import { jsx as _jsx } from "react/jsx-runtime";
import _slicedToArray from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { ChannelSelectionPage } from './pages/channel-selection';
import TrackingPage from './pages/tracking';
import { useTrackingQuery } from './hooks/use-tracking-query';
import { useAppMode } from './hooks/use-app-mode';
export default function AppRouter() {
  var order = useTrackingQuery();

  var _useAppMode = useAppMode(),
      _useAppMode2 = _slicedToArray(_useAppMode, 1),
      mode = _useAppMode2[0];

  if (mode === 'choose-channel') {
    return /*#__PURE__*/_jsx(ChannelSelectionPage, {});
  }

  if (mode === 'not-ready' && order.data || mode === 'tracking') {
    return /*#__PURE__*/_jsx(TrackingPage, {
      order: order.data
    });
  }

  return null;
}